import React from 'react';
export var Filter = function (_a) {
    var color = _a.color;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", color: color },
        React.createElement("path", { d: "M15.467 1.37a.5.5 0 0 0-.499-.534H1a.5.5 0 0 0-.499.533 7.503 7.503 0 0 0 5.982 6.814v6.583a.5.5 0 0 0 .82.384l2-1.667a.5.5 0 0 0 .18-.384V8.183a7.502 7.502 0 0 0 5.984-6.814v0Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })));
};
